/**
 * Reactive breakpoint hook for the inline-styled landing page. Returns true
 * below `maxWidth` (default 720px) so sections can swap fixed grids for a
 * stacked layout on phones/tablets.
 */

import { useEffect, useState } from "react";

export function useIsMobile(maxWidth = 720): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return isMobile;
}
